<form novalidate #currentForm="ngForm">
  <div class="form-row pb-2">
    <div class="col-md-6">
      <label>Event Type</label>
      <select class="form-control" name="event_type_id" [ngClass]="{ 'is-invalid': !eventObject.event_type_id && formSubmitted }" [(ngModel)]="eventObject.event_type_id" (change)="onEventTypeChange()">
        <option *ngFor="let eventType of formOptions.event_types" [value]="eventType.value">{{ eventType.label }}</option>
      </select>
      <div class="invalid-feedback d-block" *ngIf="!eventObject.event_type_id && formSubmitted">Event type is required</div>
    </div>
    <div class="col-md-6">
      <label>Matter</label>
      <app-matter-search [matterId]="eventObject.matter_id" (clearMatter)="clearMatterSelection()" (matter_id)="onMatterSelect($event)"></app-matter-search>
      <div class="invalid-feedback d-block" *ngIf="!eventObject.matter_id && formSubmitted">Matter is required</div>
    </div>
  </div>
  <hr />
  <div class="form-row">
    <div class="col">
      <label>When</label>
      <div class="form-row">
        <div class="col-6">
          <label class="float-left pb-1" style="position: absolute">From</label>
          <div style="height: 5px"></div>
          <app-datetime-picker #eventStart [datetime]="eventObject.start_date_struct" [timePickerEditable]="!eventObject.all_day" (ngbResult)="eventObject.start_date_struct = $event; setDefaultEndDate($event)"></app-datetime-picker>
          <div class="invalid-feedback d-block" *ngIf="formSubmitted && !eventObject.start_date_struct">From date needs to be set</div>
        </div>
        <div class="col-6">
          <label class="float-left pb-1" style="position: absolute">To</label>
          <div style="height: 5px"></div>
          <app-datetime-picker #eventEnd [datetime]="eventObject.end_date_struct" [timePickerEditable]="!eventObject.all_day" (ngbResult)="eventObject.end_date_struct = $event"></app-datetime-picker>
          <div class="invalid-feedback d-block" *ngIf="formSubmitted && !eventObject.end_date_struct">To date needs to be set</div>
        </div>
      </div>
      <div class="custom-control custom-checkbox custom-control-inline" (click)="eventObject.all_day = !eventObject.all_day; allDayChanged()">
        <input type="checkbox" class="custom-control-input" [checked]="eventObject.all_day" />
        <label class="custom-control-label">All Day</label>
      </div>
      <div class="custom-control custom-checkbox custom-control-inline" (click)="eventObject.private = !eventObject.private">
        <input type="checkbox" class="custom-control-input" [checked]="eventObject.private" />
        <label class="custom-control-label">Private</label>
      </div>
      <div class="custom-control custom-checkbox custom-control-inline" (click)="eventObject.is_active = !eventObject.is_active">
        <input type="checkbox" class="custom-control-input" [checked]="eventObject.is_active" />
        <label class="custom-control-label">Active</label>
      </div>
    </div>
  </div>
  <hr />
  <div class="form-row">
    <div class="col-md-6">
      <label>
        {{ phoneEvent ? 'Phone' : 'Where' }}
        <span class="text-muted font-italic" *ngIf="!eventObject.matter_id">&nbsp;(Select matter first)</span>
      </label>
      <app-contact-search [contactId]="contactId" (clearContact)="clearContactSelection()" (contact_id)="onContactSelect($event)"></app-contact-search>
      <div class="invalid-feedback d-block" *ngIf="!contactId && formSubmitted">Contact is required</div>
      <div class="custom-control custom-checkbox custom-control-inline" (click)="eventObject.initiates_phone_call = !eventObject.initiates_phone_call" *ngIf="phoneEvent">
        <input type="checkbox" class="custom-control-input" [checked]="eventObject.initiates_phone_call" />
        <label class="custom-control-label">We initiate phone call</label>
      </div>
    </div>
    <div class="col-md-6">
      <label>{{ phoneEvent ? 'Number' : 'Address' }}</label>
      <select class="form-control" name="address_id" [(ngModel)]="eventObject.address_id" *ngIf="!phoneEvent" [disabled]="!contactId">
        <option *ngFor="let address of addresses" [value]="address.value">{{ address.label }}</option>
      </select>
      <select class="form-control" name="phone_number_id" [(ngModel)]="eventObject.phone_number_id" *ngIf="phoneEvent" [disabled]="!contactId">
        <option *ngFor="let phoneNumber of phoneNumbers" [value]="phoneNumber.value">{{ phoneNumber.label }}</option>
      </select>
      <div class="invalid-feedback d-block" *ngIf="!phoneEvent && !eventObject.address_id && contactId && formSubmitted">Address is required</div>
      <div class="invalid-feedback d-block" *ngIf="phoneEvent && !eventObject.phone_number_id && contactId && formSubmitted">Phone is required</div>
    </div>
  </div>
  <hr />
  <div class="form-row">
    <div class="col-md-6">
      <label>
        Attendees
        <span class="text-muted font-italic" *ngIf="!eventObject.matter_id">&nbsp;(Select matter first)</span>
      </label>
      <div class="card" [ngClass]="{ 'border-danger': selectedMatterUserAttendeesCount < 1 && formSubmitted && eventObject.matter_id }">
        <div class="card-header">Matter Users</div>
        <div class="card-body limited-height-medium">
          <div class="custom-controls-stacked">
            <div class="custom-control custom-checkbox" *ngIf="formOptions.company_name && eventObject.matter_id" (click)="eventObject.intranet_attendee = !eventObject.intranet_attendee; onAttendeeCheck()">
              <input type="checkbox" class="custom-control-input" name="intranet_attendee" [checked]="eventObject.intranet_attendee" />
              <label class="custom-control-label font-weight-bold">{{ formOptions.company_name }}</label>
            </div>
            <div *ngFor="let attendee of matterUserAttendees" (click)="attendee.checked = !attendee.checked; onAttendeeCheck()" class="custom-control custom-checkbox">
              <input type="checkbox" [checked]="attendee.checked" [name]="'attendee-' + attendee.value" [(ngModel)]="attendee.checked" class="custom-control-input" />
              <label class="custom-control-label text-danger" title="Text not enabled" *ngIf="eventObject.reminder_delivery_methods.indexOf('Phone Text') > -1 && !attendee.allow_phone_text">
                {{ attendee.label }}
                <span>
                  <i class="fas fa-mobile-alt"></i>
                  <i class="fas fa-slash" style="position: relative; left: -15px"></i>
                </span>
              </label>
              <label class="custom-control-label" *ngIf="!(eventObject.reminder_delivery_methods.indexOf('Phone Text') > -1 && !attendee.allow_phone_text)">
                {{ attendee.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="invalid-feedback d-block" *ngIf="selectedMatterUserAttendeesCount < 1 && formSubmitted && eventObject.matter_id">Atleast one attendee must be selected</div>
    </div>
    <div class="col-md-6">
      <label class="invisible">Attendees</label
      ><!-- Placeholder to leave same gap as on left side -->
      <div class="card">
        <div class="card-header">Matter Contacts</div>
        <div class="card-body limited-height-medium">
          <div class="custom-controls-stacked">
            <div *ngFor="let attendee of involvementAttendees" (click)="attendee.checked = !attendee.checked" class="custom-control custom-checkbox">
              <input type="checkbox" [checked]="attendee.checked" [name]="'attendee-' + attendee.value" [(ngModel)]="attendee.checked" class="custom-control-input" />
              <label class="custom-control-label">{{ attendee.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="form-row pb-2">
    <div class="col">
      <label>Description</label>
      <textarea class="form-control" name="notes" [(ngModel)]="eventObject.notes"></textarea>
    </div>
  </div>
  <div class="form-row pb-2">
    <div class="col-md-12">
      <label>
        {{ eventObject.reminder_required ? 'Remind before' : 'Reminder' }}
        <span class="text-muted font-italic" *ngIf="!eventObject.reminder_required">&nbsp;(disabled)</span>
      </label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <div class="input-group-text bg-white">
            <input type="checkbox" name="reminder_enabled" [(ngModel)]="eventObject.reminder_required" />
            &nbsp;Enable Reminder
          </div>
        </div>
        <input type="number" name="reminder_before" class="form-control text-right" style="max-width: 100px" placeholder="Duration" [step]="eventObject.reminder_duration_unit <= 60 ? 5 : 1" [disabled]="!eventObject.reminder_required" [(ngModel)]="eventObject.reminder_duration" />
        <select class="form-control" name="reminder_duration_unit" style="max-width: 150px" [disabled]="!eventObject.reminder_required" [(ngModel)]="eventObject.reminder_duration_unit">
          <option value="60">minutes</option>
          <option value="3600">hours</option>
          <option value="86400">days</option>
        </select>
      </div>
      <div class="form-group" *ngIf="eventObject.reminder_required">
        <label>Notify reminder through</label>
        <br />
        <div *ngFor="let option of formOptions.deliver_options" class="custom-control custom-checkbox custom-control-inline" (click)="option.checked = !option.checked; setDeliveryMethods()">
          <input type="checkbox" [checked]="option.checked" class="custom-control-input" />
          <label class="custom-control-label">{{ option.label }}</label>
        </div>
        <span class="form-text text-danger" *ngIf="eventObject.reminder_delivery_methods.length < 1 && formSubmitted">Atleast one notification option needs to be checked</span>
      </div>
    </div>
  </div>
  <hr />
  <div class="form-row mb-3">
    <div class="col-6">
      <label>Repeat</label>
      <select class="form-control" name="recurring_rule_freq" [(ngModel)]="recurring.freq" (change)="buildRrule()">
        <option *ngFor="let repeat of rruleService.repeats" [value]="repeat.value">{{ repeat.label }}</option>
      </select>
    </div>
    <div class="col-6" *ngIf="recurring.freq && recurring.freq != 'NONE'">
      <label>Every</label>
      <div class="input-group">
        <input type="number" name="recurring_interval" [(ngModel)]="recurring.interval" (keyup)="buildRrule()" (change)="buildRrule()" class="form-control" />
        <div class="input-group-append">
          <span class="input-group-text">
            <span *ngIf="recurring.freq == 'DAILY'">day(s)</span>
            <span *ngIf="recurring.freq == 'WEEKLY'">week(s)</span>
            <span *ngIf="recurring.freq == 'MONTHLY'">month(s)</span>
            <span *ngIf="recurring.freq == 'YEARLY'">year(s)</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="recurring.freq == 'MONTHLY'">
    <label>Repeat by</label>
    <br />
    <div class="custom-control custom-radio custom-control-inline" (click)="recurringDays.monthType = 'day_of_month'; buildRrule()">
      <input type="radio" name="recurring_days" class="custom-control-input" [checked]="recurringDays.monthType == 'day_of_month' || !recurringDays.monthType" />
      <label class="custom-control-label">Day of month</label>
    </div>
    <div class="custom-control custom-radio custom-control-inline" (click)="recurringDays.monthType = 'day_of_week'; buildRrule()">
      <input type="radio" name="recurring_days" class="custom-control-input" [checked]="recurringDays.monthType == 'day_of_week'" />
      <label class="custom-control-label">Day of week</label>
    </div>
  </div>
  <div class="form-group" *ngIf="recurring.freq == 'WEEKLY'">
    <label *ngIf="recurring.freq == 'WEEKLY'">On Weekdays</label>
    <br *ngIf="recurring.freq == 'WEEKLY'" />
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-outline-secondary"
        style="min-width: 44px !important"
        *ngFor="let weekDay of rruleService.weekDays"
        (click)="recurringDays.by_week_day[weekDay.value] = !!!recurringDays.by_week_day[weekDay.value]; buildRrule()"
        [ngClass]="{ active: recurringDays.by_week_day[weekDay.value] }"
      >
        {{ weekDay.label }}
      </button>
    </div>
  </div>
  <div class="form-group" *ngIf="recurring.freq == 'MONTHLY' && recurringDays.monthType == 'day_of_week'">
    <div class="d-flex">
      <div style="line-height: 38px !important">
        1st Week
        <br />
        2nd Week
        <br />
        3rd Week
        <br />
        4th Week
        <br />
        5th Week
        <br />
        Last Week
      </div>
      <div class="flex-grow-1">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['1_' + weekDay.value] = !recurringDays.by_day['1_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: !!recurringDays.by_day['1_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
        <br />
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['2_' + weekDay.value] = !recurringDays.by_day['2_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_day['2_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
        <br />
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['3_' + weekDay.value] = !recurringDays.by_day['3_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_day['3_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
        <br />
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['4_' + weekDay.value] = !recurringDays.by_day['4_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_day['4_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
        <br />
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['5_' + weekDay.value] = !recurringDays.by_day['5_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_day['5_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
        <br />
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let weekDay of rruleService.weekDays"
            (click)="recurringDays.by_day['-1_' + weekDay.value] = !recurringDays.by_day['-1_' + weekDay.value]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_day['-1_' + weekDay.value] }"
          >
            {{ weekDay.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="recurring.freq == 'MONTHLY' && (recurringDays.monthType == 'day_of_month' || !recurringDays.monthType)">
    <div *ngFor="let monthDayArray of rruleService.monthDays">
      <div class="btn-group d-inline-block">
        <button type="button" class="btn btn-outline-secondary" style="min-width: 44px !important" *ngFor="let monthDay of monthDayArray" (click)="recurringDays.by_month_day[monthDay] = !recurringDays.by_month_day[monthDay]; buildRrule()" [ngClass]="{ active: recurringDays.by_month_day[monthDay] }">
          {{ monthDay < 10 ? '&nbsp;' : '' }}{{ monthDay }}
        </button>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="eventObject.rrule_text">
    <p>
      <b>Repeats:&nbsp;</b><span class="text-info">{{ eventObject.rrule_text }}</span>
    </p>
  </div>
  <div class="form-row">
    <div class="col" *ngIf="recurring.freq && recurring.freq != 'NONE'">
      <label class="float-left pb-1" style="position: absolute">Until</label>
      <div class="d-flex">
        <div class="pr-2">
          <div style="height: 37px"></div>
          <div class="custom-control custom-checkbox" (click)="eventObject.repeats_forever = !eventObject.repeats_forever">
            <input type="checkbox" name="repeats_forever" class="custom-control-input" [checked]="eventObject.repeats_forever" />
            <label class="custom-control-label">Repeat forever</label>
          </div>
        </div>
        <div class="flex-grow-1" *ngIf="!eventObject.repeats_forever">
          <app-datetime-picker #eventUntilTime [datetime]="eventObject.until_time_struct" (ngbResult)="eventObject.until_time_struct = $event"></app-datetime-picker>
          <small class="form-text text-muted">Last date for event</small>
          <div class="invalid-feedback d-block" *ngIf="formSubmitted && !eventObject.until_time_struct">Until date needs to be set</div>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="form-row py-2 sticky-top">
    <div class="col-4">
      <button type="button" class="btn btn-primary btn-block" [disabled]="saving" (click)="save('save_close')">Save &amp; Close</button>
    </div>
    <div class="col-4">
      <button type="button" class="btn btn-primary btn-block" [disabled]="saving" (click)="save('save_view')">Save &amp; View</button>
    </div>
    <div class="col-4">
      <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="saving" (click)="formResult.emit('cancelled')">Cancel</button>
    </div>
  </div>
  <div class="form-row pt-2 pb-1">
    <div class="col">
      <div class="card">
        <h5 class="card-header">
          Overlapping Events
          <small>
            <app-badge badgeType="secondary">
              {{ overlappingEvents.length }}
            </app-badge>
          </small>
        </h5>
        <ul class="list-group list-group-flush" *ngIf="overlappingEvents.length > 0">
          <li class="list-group-item text-white cursor-pointer border-white" [ngStyle]="{ 'background-color': event.color }" *ngFor="let event of overlappingEvents" (click)="showEvent.emit(event.id)">
            {{ event.id }}&nbsp;
            <span class="font-italic">{{ event.formattedDateTitle }} {{ event.event_type_name }}</span>
            &nbsp;{{ event.display_name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</form>
<ng-template #event_show>
  <div class="modal-header">
    <h4 class="modal-title">Event</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="showModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-event-show
      [eventId]="eventShowId"
      [modalMode]="true"
      [allowEdit]="false"
    ></app-event-show>
  </div>
</ng-template>